import React, { useEffect, useState } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Icon } from '../../components';
import SummaryIndex from './FeeProcessDetails/SummaryIndex';
import { showFeePaymentProcessRequest } from '../../requests/feeProcesses';

const FeeProcessEdit = props => {
  const { location, match } = props;
  const { id } = match.params;
  const [moreData, setMoreData] = useState(false);
  const [feePaymentProcess, setFeePaymentProcess] = useState({});
  const history = useHistory();
  const dispatch = useDispatch();
  const { onlyShow } = location.state ?? {};
  const vOnlyShow = onlyShow || false;

  const handleFeeProcess = () => {
    showFeePaymentProcessRequest(id, {
      dispatch,
      service: 'payroll',
      successCallback: response => {
        setFeePaymentProcess(response.data);
      }
    });
  };
  const monthName = feePaymentProcess ? `${feePaymentProcess.month} ${feePaymentProcess.year}` : '';
  const ProcessStatus = () => {
    if (feePaymentProcess?.status === 'open') {
      return <h4 className="text-uppercase text-secondary my-0">Mes Abierto</h4>;
    }
    if (feePaymentProcess?.status === 'closed') {
      return <h4 className="text-uppercase text-danger my-0">Mes Cerrado</h4>;
    }
    return <></>;
  };
  useEffect(handleFeeProcess, [moreData]);

  return (
    <>
      <Row className="mt-4">
        <Col
          md={1}
          xs={2}
          style={{
            maxWidth: '3rem'
          }}
        >
          <Col className="pl-1 pr-1">
            <Button
              variant="circle-dark"
              className="btn-circle mt-3"
              block
              onClick={() => {
                history.push(`/fee_processes`);
              }}
            >
              <Icon icon="chevron-back" />
            </Button>
          </Col>
        </Col>
        <Col md={11} xs={10}>
          <Col xs={12}>
            <h2 className="mb-2 mt-2">Procesos de Honorarios {monthName}</h2>
          </Col>
          <Col className="ml-4">
            <ProcessStatus />
          </Col>
        </Col>
      </Row>
      {feePaymentProcess?.id && (
        <SummaryIndex
          feePaymentProcess={feePaymentProcess}
          setMoreData={setMoreData}
          moreData={moreData}
          onlyShow={vOnlyShow}
        />
      )}
    </>
  );
};

export default FeeProcessEdit;
